'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const defaultPropValue = (value)=>({
        table: {
            defaultValue: {
                summary: value
            }
        }
    });
const componentDescription = (description)=>({
        docs: {
            description: {
                component: description
            }
        }
    });

exports.componentDescription = componentDescription;
exports.defaultPropValue = defaultPropValue;
//# sourceMappingURL=docs.js.map
